import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import { NETWORK_THREAT_PATH } from "@js2/path";
import { getRoute } from "@modules/network/components/common/NetworkLink";
import { useNetworkRoute } from "@modules/network/hooks/useNetworkRoute";

const RelationsNavItem = () => {
  const [name = "", value = ""] = useNetworkRoute();
  const link = getRoute(NETWORK_THREAT_PATH.RELATIONS, name, value);
  return (
    <Nav.Item>
      <Nav.Link
        as={Link}
        to={link}
        key="relations"
        eventKey="relations"
        data-testid="relations-nav-item"
      >
        Relations
      </Nav.Link>
    </Nav.Item>
  );
};

export default RelationsNavItem;
